import React from 'react'
import PropTypes from 'prop-types'
import HeaderRegular from './header-regular'
import HeaderSearching from './header-searching'

const Header = (props) => {
  return (
    props.isSearching ?
      <HeaderSearching {...props} />
      : <HeaderRegular {...props} />
  )
}

Header.propTypes = {
  isSearching: PropTypes.bool
}

export default Header


// WEBPACK FOOTER //
// ./src/ui/header/header.js